import { HttpService } from '../shared/core/http.service';

const PATCH_FLAG = '__scrimsPasProxyAuthPatched';

export function installPasProxyAuthHeaders(httpService: HttpService): void {
  const browserWindow = window as any;
  browserWindow.__scrimsGetApiToken = () => httpService.tokenAPI || '';
  if (browserWindow[PATCH_FLAG]) {
    return;
  }
  browserWindow[PATCH_FLAG] = true;

  const originalSetRequestHeader = XMLHttpRequest.prototype.setRequestHeader;
  XMLHttpRequest.prototype.setRequestHeader = function(name: string, value: string) {
    if (name && name.toLowerCase() === 'authorization') {
      (this as any).__scrimsHasAuth = true;
    }
    return originalSetRequestHeader.apply(this, arguments);
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function() {
    (this as any).__scrimsRequestUrl = arguments[1];
    return originalOpen.apply(this, arguments);
  };

  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    const url = String((this as any).__scrimsRequestUrl || '');
    if (needsScrimsAuth(url) && !(this as any).__scrimsHasAuth) {
      const token = browserWindow.__scrimsGetApiToken();
      if (token) {
        originalSetRequestHeader.call(this, 'Authorization', 'Bearer ' + token);
      }
    }
    return originalSend.apply(this, arguments);
  };

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const url = requestUrl(input);
    if (!needsScrimsAuth(url)) {
      return originalFetch(input, init);
    }

    const token = browserWindow.__scrimsGetApiToken();
    if (!token) {
      return originalFetch(input, init);
    }

    const headers = new Headers(init && init.headers);
    if (!headers.has('Authorization')) {
      headers.set('Authorization', 'Bearer ' + token);
    }
    return originalFetch(input, { ...(init || {}), headers });
  };
}

function needsScrimsAuth(url: string): boolean {
  return url.indexOf('pas-proxy') >= 0
    || url.indexOf('documents/getfile') >= 0
    || url.indexOf('documents/UploadPdfToConvertToJpeg') >= 0
    || /\/documents\/[^/?]+\/beginViewing/.test(url);
}

function requestUrl(input: RequestInfo | URL): string {
  if (typeof input === 'string') {
    return input;
  }
  if (input instanceof URL) {
    return input.toString();
  }
  return input.url;
}
